define(['assets/js/backbone-extended', 'assets/js/modules/design/designFaceProcessModel'], function(
    backboneExtended,
    DesignFaceProcessModel
) {
    return backboneExtended.NestedModel.extend(
        {
            idAttribute: 'type',
            relations: {
                processes: backboneExtended.Collection.extend({
                    model: DesignFaceProcessModel
                })
            },
            defaults: {
                type: null
            }
        },
        {
            TYPE_FRONT: 'front',
            TYPE_BACK: 'back'
        }
    );
});
